<forge-scaffold>
  <div slot="body" class="conn-group-action--dropdown" fxLayout="column" fxLayoutAlign="center start">
    <div fxLayout="row" fxLayoutAlign="space-between">
      @if (ConnGroupList) {
        <forge-select autofocus label="Connection Group" [density]="density"
          [disabled]="connGroupDisabled" [value]="ConnGroupID" (change)="updateConnGroup($event.detail)"
          (keydown)="selectKeyUp($event)" aria-label="Conn-Group">
          @for (item of ConnGroupList; track item) {
            <forge-option [value]="item.Value">
              {{item.Display}}
            </forge-option>
          }
        </forge-select>
      }
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between">
      <forge-checkbox [checked]="updateConnGroupDefault" (change)="checked($event)"
        [disabled]="connGroupDisabled">
        Set as Default Connection at Login
      </forge-checkbox>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between">
      @if (DepartmentList) {
        <forge-select label="Department" [value]="DepartmentID"
          [disabled]="departmentDisabled" (change)="updateDepartment($event.detail)"
          (keydown)="selectKeyUp($event)" [density]="density" aria-label="Department">
          @for (item of DepartmentList; track item) {
            <forge-option [value]="item.Value">
              {{item.Display}}
            </forge-option>
          }
        </forge-select>
      }
    </div>
  </div>

  <forge-toolbar no-border slot="footer">
    <forge-button slot="end" variant="outlined" (click)="cancel()" telemetry="Submission-ConnGroupCancel">
      Cancel
    </forge-button>

    <forge-button slot="end" variant="raised" (click)="save()" [disabled]="!canSave"
      telemetry="Submission-ConnGroupSave" style="margin-left:1em;">
      Save
    </forge-button>
  </forge-toolbar>
</forge-scaffold>